import { Container } from '../../../odie';
import { WormBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { getMatch2AssetPath } from '../../util/assets';
import { MovieClip } from '@play-co/timestep-core/ui';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/butterfly'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class WormBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: WormBlockProps) {
    super();
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    blockPositionView(this, props);
    this.startAnimation();
  }

  private startAnimation(): void {
    this.movieclip.play('worm_state01', null, true);
  }

  public stopAnimation(): void {
    this.movieclip.stop();
  }

  public static assets() {
    return Object.values(manifest());
  }
}
